// components/PrivateRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

// Signed out: go to login and come BACK here afterwards. The page used to send plain /login, so a
// link from a run email or a colleague was lost at sign-in; login already honours ?redirect=.
const PrivateRoute = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.auth.isAuthenticated);
  const location = useLocation();
  if (isLoggedIn) return children;
  const target = `${location.pathname}${location.search}`;
  const to = target && target !== "/" ? `/login?redirect=${encodeURIComponent(target)}` : "/login";
  return <Navigate to={to} replace />;
};

export default PrivateRoute;
